<template>
  <div class="survey-thank-you">
    <div class="survey-thank-you__wrapper">
      <img
        class="survey-thank-you__img"
        src="@/assets/img/survey-thank-you-img.svg"
        alt="Survey image"
      />
      <div>
        <h1 class="survey-thank-you__title">Thank You!</h1>
        <p class="survey-thank-you__description">
          Thank you so much for you time.
          And please remember that there are no good or bad answers here.
          This test is only for you to find a project in which you will feel comfortable
          with the organisational culture and your future employer.
        </p>
      </div>
    </div>

    <DeveloperSummary class="survey-thank-you__card"/>
    <a href="https://bench.applover.com/dev" class="survey-thank-you__btn">HOME PAGE</a>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import DeveloperSummary from '@/components/Developer/Join/Summary.vue';

export default {

  components: {
    DeveloperSummary,
  },

  computed: {
    ...mapState('developer', ['developer']),
  },

  created() {
    localStorage.removeItem('Bench-Register-Step');
    localStorage.removeItem('Bench-Role');
    localStorage.removeItem('Bench-Auth-Token');
  },
};
</script>

<style lang="scss" scoped>
.survey-thank-you {
  margin: 0 auto;
  @include desktop {
    width: 920px;
  }

  &__wrapper {
    align-items: center;
    display: flex;
    justify-content: center;
    padding-top: 40px;
    flex-direction: column;
    @include tablet {
      flex-direction: row;
      width: 920px;
    }
  }

  &__img {
    margin-bottom: 12px;
    @include tablet {
      padding-right: 64px;
      margin-bottom: 32px;
    }
  }

  &__title {
    color: $main--headers;
    font-size: 28px;
    line-height: 33px;
    margin-bottom: 16px;
    text-align: center;
    @include tablet {
      text-align: left;
    }
  }

  &__description {
    color: $main--text;
    text-align: center;
    opacity: 0.7;
    font-size: 14px;
    @include tablet {
      width: 445px;
      text-align: left;
    }
  }

  &__card {
    background: #FFFFFF;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 8px;
    max-width: 636px;
    margin: 0 auto;
    padding: 32px 32px 64px 32px;
    text-align: center;
    max-width: 920px;
    text-align: left;
  }

  &__btn {
    max-width: 255px;
    height: 50px;
    border-radius: 4px;
    background-color: $color--blue;
    color: white;
    text-decoration: none;
    text-transform: uppercase;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 40px 0 50px ;
  }
}
</style>
